export default "__VITE_PUBLIC_ASSET__50278993__"